import { createFileRoute, redirect } from '@tanstack/react-router'
import { CustomerHubRedirect } from './-ui/customer-hub-redirect'

// Legacy deep-link: задачи заказчика живут в табе «Задачи» его хаба.
// Employee-экран — /tasks.
export const Route = createFileRoute('/_app/my-tasks')({
  beforeLoad: ({ context }) => {
    if (context.session?.kind === 'employee') throw redirect({ to: '/tasks' })
  },
  head: () => ({ meta: [{ title: 'Задачи · STIT Deal' }] }),
  component: () => <CustomerHubRedirect tab="tasks" />,
})
